import React from 'react';

const Blog = () => {
  return (
    <div className="blog">
      <div className="container">
        <h1>Blog</h1>
        <p>Stay updated with our latest news and articles.</p>
      </div>
    </div>
  );
};

export default Blog;